import { Component, ChangeDetectionStrategy } from '@angular/core';
import { DeveloperInsightSectionComponent } from '../developer-insight-section';

@Component({
  selector: 'app-developer-compliance-risk-analysis',
  templateUrl: './developer-compliance-risk-analysis.component.html',
  styleUrls: [
    './developer-compliance-risk-analysis.component.scss',
    '../developer-insight-section.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeveloperComplianceRiskAnalysisComponent extends DeveloperInsightSectionComponent {
  riskOverview: any;
  complianceOverview: any;

  constructor() {
    super();
    this._developerStateService.developer$.subscribe(data => {
      this.complianceOverview = data?.complianceRiskOverview;
      this.riskOverview = data?.riskOverview;
    });
  }
}
